import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import api from "services/api";
import { Page } from "v2/components";
import { getContractDisplayName } from "v2/utils/getContractDisplayName";

import { RetificarView } from "./Retificar.View";

/**
 * Só o invólucro: busca o contrato para o título e monta a `Page`, igual ao `BateCadastral`.
 * Sem isto a tela abria fora do layout, sem cabeçalho nem navegação.
 *
 * O `bate-get-details` é o mesmo endpoint que a tela do bate usa, então o título e a rota de
 * voltar ficam idênticos entre as duas.
 */
interface IResponse {
  workspace: {
    id: string;
    workspaceRules?: Array<{
      params?: {
        payload?: {
          rules?: {
            rulesRegister?: {
              policyContractNumber?: string;
            };
          };
        };
      };
    }>;
    sellerOrganization: {
      id: string;
      corporateName: string;
    };
    buyerOrganization: {
      id: string;
      corporateName: string;
    };
    product: {
      id: string;
      name: string;
      productType: string;
      supplierOrganization: {
        id: string;
        corporateName: string;
      };
    };
  };
  bateWorkspaceActivityId: string;
  exportWorkspaceActivityId: string;
}

export function Retificar() {
  const { workspaceId } = useParams() as { workspaceId: string };

  const { data, isFetching, isFetched, isError } = useQuery({
    queryKey: ["pageDetailBate", workspaceId],
    queryFn: () => api.get<{ data: IResponse }>(`/v2/workspaces/${workspaceId}/bate-get-details`),
    select: (response) => response.data.data,
  });

  return (
    <>
      {!isFetched && isFetching && <div>Loading...</div>}
      {!isFetched && isError && <div>Error...</div>}
      {data && (
        <Page title={getContractDisplayName(data.workspace)} backRoute={`/v2/workspaces/${data.workspace.id}`}>
          <Page.Tab name="Exceções">
            <RetificarView />
          </Page.Tab>
        </Page>
      )}
    </>
  );
}
